var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCheckmarkCircle = function SvgCheckmarkCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "checkmark-circle_svg__icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.997 14.563c3.599 0 6.57-2.97 6.57-6.563 0-3.593-2.977-6.563-6.577-6.563-3.592 0-6.557 2.97-6.557 6.563 0 3.593 2.971 6.563 6.564 6.563Zm0-1.307A5.231 5.231 0 0 1 2.754 8c0-2.914 2.33-5.25 5.236-5.25A5.246 5.246 0 0 1 13.253 8a5.238 5.238 0 0 1-5.256 5.256ZM7.31 11.02a.652.652 0 0 0 .565-.323l2.863-4.456c.089-.134.159-.286.159-.426 0-.323-.28-.533-.584-.533-.19 0-.362.108-.495.324l-2.527 4.03-1.18-1.491c-.153-.197-.305-.26-.49-.26a.558.558 0 0 0-.564.565c0 .152.057.292.165.431l1.498 1.822c.171.216.355.317.59.317Z",
    fill: "currentColor"
  })));
};

export default SvgCheckmarkCircle;